import { PageHero } from "../components/layout/PageHero";

export function NotFoundPage() {
  return (
    <PageHero
      eyebrow="404"
      title="Essa rota ainda não existe."
      text="A superfície pública está sendo construída em etapas pequenas. Use a home para voltar para a jornada principal."
      primary={{ href: "/", label: "Voltar para THH" }}
      secondary={{ href: "/beauty", label: "Explorar Beauty" }}
    />
  );
}
